class BoneController {
    boneName;
    bone;
    /**
     * Object responsible for holding the bone of an armature.
     * @param boneName The name of the bone.
     * @param mesh The mesh from which the bone will be retrieved.
     * @throws If a bone with the given name could not be found.
     */
    constructor(boneName, mesh) {
        this.boneName = boneName;
        this.bone = this.getCorrespondingBone(mesh);
    }
    /**
     * Retrieve the bone based on the `name` property from the given mesh.
     * @param mesh The mesh to get the bone from.
     * @returns The retrived bone.
     * @throws If no bone with a name matching the `boneName` property can be found.
     */
    getCorrespondingBone(mesh) {
        const bone = mesh.getObjectByName(this.boneName);
        if (!bone)
            throw new Error(`Could not find bone with name '${this.boneName}' in ${mesh}.`);
        return bone;
    }
    get getBone() {
        return this.bone;
    }
}
export { BoneController };
